// Presentation only: API filtering and stored evidence always retain the original key.
export function formatRdSignalName(key: string, tentative = false): string {
  const words = key
    .replace(/^risk:/, '')
    .replaceAll(/[-:_]+/g, ' ')
    .trim()
    .replaceAll(/\b[a-z]/g, (letter) => letter.toUpperCase());
  if (tentative && key.startsWith('risk:') && words) {
    return `Possible ${words}`;
  }

  return words || key;
}

export function formatRdSignalValue(value: string, signal?: string): string {
  if (!signal?.startsWith('risk:')) {
    return value;
  }

  const leaf = value.split(' / ').at(-1)?.trim() ?? '';
  return leaf || value;
}

// Only the `risk:` namespace is analyst-facing; routing and other signals stay in stored evidence.
export function isRiskSignal(signal: unknown): boolean {
  if (typeof signal !== 'object' || signal === null) {
    return false;
  }

  const {key} = signal as {key?: unknown};
  return typeof key === 'string' && key.startsWith('risk:');
}

// "Possible <risk> - <classification>": the classification is the last segment of a
// "Vertical / Category / Classification" path, which stays in full in the signal details.
export function formatRdFinding(key: string, path: string): string {
  const label = formatRdSignalName(key, true);
  const leaf = path.split('/').at(-1)?.trim() ?? '';
  if (leaf === '') {
    return label;
  }

  const risk = label.replace(/^Possible /, '');
  return leaf.toLowerCase().startsWith(risk.toLowerCase())
    ? `Possible ${leaf}`
    : `${label} - ${leaf}`;
}
